import React from "react";
import Logout from "pages/SalesDeveloper/Authentication/Logout";
import Pages404 from "pages/Utility/pages-404";
import Home from "pages/Utility/home";
import Pages500 from "pages/Utility/pages-500";
import { Redirect } from "react-router-dom"
import Login from "pages/SalesDeveloper/Authentication/Login";
import ManageClients from "pages/SalesDeveloper/ManageClients";
import ForgetPassword from "pages/SalesDeveloper/Authentication/ForgetPassword";
import ResetPassword from "pages/SalesDeveloper/Authentication/Resetpassword";
import ViewClientPage from "pages/SalesDeveloper/ManageClients/ViewClient";
import DealsPage from "pages/SalesDeveloper/Deals";
import ViewDealPage from "pages/SalesDeveloper/Deals/ViewDeal";
import ManageInventory from "pages/SalesDeveloper/Inventory";
import Wirframe from "pages/SalesDeveloper/Inventory/Wirframe";
import ProfilePage from "pages/SalesDeveloper/Profile";
import BuildingList from "pages/SalesDeveloper/Building";
import PropertyList from "pages/SalesDeveloper/Property";
import CompoundList from "pages/SalesDeveloper/Compound";
import Cards from "pages/SalesDeveloper/Compound/Cards";
import CompoundPage from "pages/SalesDeveloper/Compound/AddCompound";
import AddPayment from "pages/SalesDeveloper/PaymentPlan/AddPayment";
import PaymentPlan from "pages/SalesDeveloper/PaymentPlan";
import EditCompound from "pages/SalesDeveloper/Compound/EditCompound"
import AddBuilding from "pages/SalesDeveloper/Compound/AddBuilding"
import AddProperty from "pages/SalesDeveloper/Compound/AddProperty"
import CreateBuilding from "pages/SalesDeveloper/Building/CreateBuilding"
import EditBuilding from "pages/SalesDeveloper/Building/EditBuilding"
import EditProperty from "pages/SalesDeveloper/Property/EditProperty";
import CreateProperty from "pages/SalesDeveloper/Property/CreateProperty";
import AddMode from "pages/SalesDeveloper/Compound/InteractiveMode/AddMode";

const salesDeveloperRoutes = [
  { path: "/logout", component: Logout },

  { path: "/pages-404", component: Pages404 },
  { path: "/home", component: Home },

  { path: "/profile", component: ProfilePage },
  { path: "/manage-clients", component: ManageClients },
  { path: "/manage-clients/view-client/:id", component: ViewClientPage },

  { path: "/compound/compound-list/:id", component: CompoundList },
  { path: "/add-mode", component: AddMode },
  { path: "/compound/compound-update/:id", component: EditCompound },
  { path: "/create-building/:id", component: AddBuilding },
  { path: "/create-property", component: AddProperty },
  { path: "/compound", component: CompoundPage },
  { path: "/cards/:id", component: Cards },

  { path: "/payment-plan/:id", component: PaymentPlan },
  { path: "/add-payment/:id?", component: AddPayment }, 

  
  { path: "/building", component: BuildingList },
  { path: "/add-building", component: CreateBuilding },
  { path: "/edit-building/:id", component: EditBuilding },

  { path: "/property", component: PropertyList },
  { path: "/add-property", component: CreateProperty },
  { path: "/edit-property/:id", component: EditProperty },

  { path: "/inventory", component: ManageInventory },
  { path: "/inventory/wirframe", component: Wirframe },

  { path: "/deals", component: DealsPage },
  { path: "/deals/view-deal/:id", component: ViewDealPage },

  { path: "*", component: () => <Redirect to='/sales-developer/pages-404' /> },
  // this route should be at the end of all other routes
];

const salesDeveloperAuthRoutes = [
  { path: "/login", component: Login },
  { path: "/forget-password", component: ForgetPassword },
  { path: "/reset-password", component: ResetPassword },
  { path: "/pages-500", component: Pages500 },
];

export { salesDeveloperRoutes, salesDeveloperAuthRoutes };
